import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'gg-ach-icon',
  templateUrl: './ach-icon.component.html',
  styleUrls: ['./ach-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AchIconComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
